import React, {memo} from 'react';
import styled from 'styled-components';
import ImageFadeIn from 'react-image-fade-in';
import numeral from 'numeral';
import {Subhead, Caption1, Title3} from '../../../../../components/Typography';
import appConfig from '../../../../../../app-config';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.isNoImage
      ? null
      : props.theme.productPreviewAlignImage === 'left'
      ? '150px 1fr'
      : '1fr'};
  grid-gap: 20px;
  // justify-content: flex-start;
  align-items: center;

  padding: 0 10px;
  cursor: pointer;
  &:hover {
    background: ${props => props.theme.menuCardHoverColor};
    transition: all 0.25s ease;
  }

  &:hover #menuB-ProductDescription {
    color: ${props =>
      props.isAvailable
        ? props.theme.darkGray
        : props.theme.unavailableProductColor};
  }

  @media (max-width: 400px) {
    grid-template-columns: ${props =>
      props.isNoImage ? null : '91px 1fr !important'};
    grid-gap: 16px !important;
    padding: 0;
  }

  @media (max-width: 500px) {
    grid-template-columns: ${props => (props.isNoImage ? null : '130px 1fr')};
    grid-gap: 10px;
    padding: 0;
    :last-of-type {
      padding-bottom: 20px;
    }
  }

  @media (min-width: 501px) and (max-width: 768px) {
    grid-template-columns: ${props => (props.isNoImage ? null : '185px 1fr')};
    grid-template-rows: 185px;
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    grid-template-columns: ${props => (props.isNoImage ? null : '120px 1fr')};
  }
`;

const InfoWrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${props => props.theme.lightGray};
  cursor: ${props => (props.isAvailable ? 'pointer' : 'default')};
  align-self: stretch;

  @media (max-width: 786px) {
    grid-template-columns: 1fr;
    grid-gap: 10px;
    padding: 4px 0;
  }
`;

const Image = styled(ImageFadeIn)`
  //height: 100px;
  //width: 100px;
  object-fit: cover;
  height: 150px;
  border-radius: ${props =>
    props.theme.productPreviewImageShape === 'circle' ? '50%' : '8px'};
  border: ${props => props.theme.productPreviewBorder};
  order: ${props => (props.theme.productPreviewAlignImage === 'left' ? 0 : 2)};
  filter: ${props => (props.isAvailable ? null : 'grayscale(0.9)')};
  // width: calc((((100vw - 20% - 48px) / 2) - 48px) / 3);

  @media (max-width: 400px) {
    height: 91px;
  }

  @media (max-width: 500px) {
    height: 130px;
  }

  @media (min-width: 501px) and (max-width: 768px) {
    height: 185px;
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    height: 120px;
  }
`;

const NameAndDescription = styled.div`
  display: grid;
  grid-gap: 10px;
`;

const Name = styled(Title3)`
  // text-transform: capitalize;
  font-weight: 600;
  color: ${props =>
    props.isAvailable ? 'inherit' : props.theme.unavailableProductColor};
`;

const Description = styled(Caption1)`
  color: ${props =>
    props.isAvailable
      ? props.theme.secondaryColor
      : props.theme.unavailableProductColor};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 20px; /* fallback */
  max-height: 120px; /* fallback */
  -webkit-line-clamp: 6; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

const Price = styled(Subhead)`
  justify-self: flex-end;
  color: ${props =>
    props.isAvailable
      ? props.theme.darkGray
      : props.theme.unavailableProductColor};
  display: ${props =>
    props.theme.productPreviewShowPrice ? 'inherit' : 'none'};
  float: right;
  margin-top: 10px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02px;
  text-align: right;
  color: #737a87;
`;

const ProductPreview = ({product, handleProductPreviewClick}) => {
  return (
    <Wrapper
      isNoImage={appConfig.isNoImage}
      onClick={() =>
        product.is_product_available
          ? handleProductPreviewClick(product.product_id, product)
          : null
      }
      isAvailable={product.is_product_available}
    >
      {!appConfig.isNoImage && (
        <Image
          isAvailable={product.is_product_available}
          src={product.image_url}
        />
      )}

      <InfoWrapper isAvailable={product.is_product_available}>
        <NameAndDescription>
          <Name
            id="menuB-ProductName"
            isAvailable={product.is_product_available}
          >
            {product.name}
          </Name>
          {product.user_description && (
            <Description
              id="menuB-ProductDescription"
              isAvailable={product.is_product_available}
            >
              {product.user_description}
            </Description>
          )}
        </NameAndDescription>
        <Price
          id="menuB-ProductPrice"
          isAvailable={product.is_product_available}
        >
          {numeral(
            product.default_items_price
              ? product.default_items_price
              : product.price
          ).format('$0.00')}
        </Price>
      </InfoWrapper>
    </Wrapper>
  );
};

export default ProductPreview;
